var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function FormError() {
    this.init = function() {
        var $error = $( '.page-template-page-contact .validation_error' ),
            $formTop = $( '.gform_fields .gfield_html:first-child');

        if ( $error.length && $formTop.length ) {
            $error.appendTo( $formTop );
        }
    };

    this.init();
}

module.exports = FormError;
